import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#008000', // A
          'primary-darken1': '#36c236', // R
          'primary-lighten1': '#D8F2D8', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#000000', // B
          'secondary-darken1': '#015001', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#008000', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#008000', // H
          topSecondaryBtn: '#FFFFFF', // I
          topSecondaryBtnText: '#000000', // J
          topPrimaryBtn: '#008000', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#008000', // N
          secondaryOutLineBtnText: '#008000', // O
          topBtnUpTextSp: '#008000', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#008000',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#008000',
          accent: '#008000', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
